const initialState = {
    isAssigningOwner: false,
    isAssigningTeamsTerritories: false,
}

export default initialState;
